/* Product-card image carousel (quick view) + color swatch jumps.
   Loaded once per page from card-product.liquid; the guard below makes
   duplicate <script> tags (one per card) harmless. */
if (!customElements.get('card-carousel')) {
  class CardCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.card-carousel__track');
      this.dots = Array.from(this.querySelectorAll('.card-carousel__dot'));
      if (!this.track) return;

      this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });

      // The carousel sits above Dawn's full-card link overlay, so restore
      // tap/click-to-open. A touch swipe that scrolls never fires click.
      this.track.addEventListener('click', (e) => {
        const url = this.dataset.url;
        if (!url) return;
        if (e.metaKey || e.ctrlKey) {
          window.open(url, '_blank');
        } else {
          window.location.href = url;
        }
      });

      this.querySelectorAll('.card-carousel__arrow').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.go(this.index() + Number(btn.dataset.dir));
        });
      });

      // Swatches live in the card content, outside <card-carousel>
      const wrapper = this.closest('.card-wrapper, .cad-coll__card');
      if (wrapper) {
        wrapper.querySelectorAll('.card-swatch[data-slide-target]').forEach((sw) => {
          sw.addEventListener('click', (e) => {
            if (e.metaKey || e.ctrlKey) return; // allow open-variant-in-new-tab
            e.preventDefault();
            e.stopPropagation();
            this.go(Number(sw.dataset.slideTarget));
            wrapper
              .querySelectorAll('.card-swatch')
              .forEach((s) => s.classList.toggle('is-active', s === sw));
          });
        });
      }
    }

    index() {
      return Math.round(this.track.scrollLeft / this.track.clientWidth);
    }

    go(i) {
      const max = this.track.children.length - 1;
      const target = Math.max(0, Math.min(i, max));
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior: 'smooth' });
    }

    onScroll() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        const i = this.index();
        this.dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      });
    }
  }
  customElements.define('card-carousel', CardCarousel);
}
